import * as React from "react";
import { v4 as uuidv4 } from "uuid";
import Container from "../../common/Container";
import { CaretDownOutlined } from "@ant-design/icons";
import { color } from "../../../styles/color";
import {
  LocationOutter,
  MobileBtn,
  BoxMask,
  Box,
  CnCounty,
} from "../../../styles/MatchPage";
import type { Obj } from "../../../client_types";

interface IProps {
  province: Obj[];
  city: string;
  onClick: (provinceID: number, provinceName: string) => void;
}

const LocationMenu = ({ province, city, onClick }: IProps) => {
  const [open, setOpen] = React.useState(false);
  const [active, setActive] = React.useState<null | number>(0);

  return (
    <LocationOutter className="locationMenu">
      <Container>
        <MobileBtn onClick={() => setOpen(!open)}>
          <>
            <CaretDownOutlined style={{ color: `${color.default}` }} />
            {city != null ? city : "选择地区"}
          </>
        </MobileBtn>
        <BoxMask
          className={`boxMask ${open ? "open" : ""}`}
          open={open}
          onClick={() => setOpen(false)}
        />
        <Box className={`box ${open ? "open" : ""}`} open={open}>
          {province &&
            province.map((d, i) => (
              <CnCounty
                className="CnCounty"
                key={uuidv4()}
                onClick={() => {
                  setOpen(false);
                  setActive(i);
                  onClick(d.ProvinceID, d.ProvinceName);
                }}
                style={{
                  backgroundColor:
                    active === i ? `${color.markedSecondary}` : "white",
                  color: active === i ? "white" : `${color.default}`,
                  transform: active === i ? "translate(0)" : "",
                  boxShadow: active === i ? "0 0" : "",
                }}
              >
                {d.ProvinceName}
              </CnCounty>
            ))}
        </Box>
      </Container>
    </LocationOutter>
  );
};
export default LocationMenu;
